// userinfo type
export const SET_USER_INFO = 'SET_USER_INFO'
// theme type
export const SET_THEME = 'SET_THEME'
// client config type
export const CLIENT_USER_CONFIG = 'CLIENT_USER_CONFIG'
